import { render, staticRenderFns } from "./BlockConfig.vue?vue&type=template&id=4dd8502e&scoped=true"
import script from "./BlockConfig.vue?vue&type=script&lang=js"
export * from "./BlockConfig.vue?vue&type=script&lang=js"
import style0 from "./BlockConfig.vue?vue&type=style&index=0&id=4dd8502e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd8502e",
  null
  
)

export default component.exports